export default {
  httpApi: ['//localhost:4980'],
  appSettings: {
    tus: true,
    tusd: false,
    chunkSize: 10 * 1024 * 1024,
    parallelUploads: 5,
    endpoint: '//localhost:4980/api/0/tus'
  },
  websocket: {
    url: 'ws://localhost:8980/sockjs',
    api: '',
    pingInterval: 50 * 1000,
    maxPingInterval: 2 * 60 * 1000,
    maxWaitingForcePing: 5 * 1000
  }
};